import { render, staticRenderFns } from "./email_template.vue?vue&type=template&id=71d44fa0&scoped=true&"
import script from "./email_template.vue?vue&type=script&lang=js&"
export * from "./email_template.vue?vue&type=script&lang=js&"
import style0 from "./email_template.vue?vue&type=style&index=0&id=71d44fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d44fa0",
  null
  
)

export default component.exports